import { Typography } from '@cleartrip/ct-design-components'
import Image from 'next/image'
import { Fragment } from 'react'

import { ELITE_MEMBERSHIP_ASSETS } from '@/constants/components/eliteMembership'
import { replacePlaceholders } from '@/utils'

// Splits the copy into the strike-through price token and the Elite logo token (shown as a pill)
// API may send "{Elite}" as a placeholder or bare "Elite"
const ELITE_SEGMENT_REGEX = /(₹\s?\{strikeAmount\}|\{elite\}|\bElite\b)/gi

type Props = {
    text: string
    placeholderMap?: Record<string, any>
}

const ElitePill = () => (
    <span
        className="flex-inline flex-middle flex-center"
        style={{
            padding: '4px 6px',
            borderRadius: '9999px',
            background: 'linear-gradient(120deg, #FE5E27 5%, #FA4ADD 100%)',
            marginLeft: '2px',
            verticalAlign: 'middle'
        }}
    >
        <Image
            unoptimized
            alt="Elite"
            className="d-block"
            height={9}
            src={ELITE_MEMBERSHIP_ASSETS.logo}
            style={{ height: '8.5px', width: 'auto' }}
            width={20}
        />
    </span>
)

const TextSegment = ({ value, bold = false }: { value: string; bold?: boolean }) =>
    value ? (
        <Typography
            className="d-inline"
            color="primary"
            componentNode="span"
            css={bold ? { fontWeight: 600 } : undefined}
            variant="P3"
        >
            {value}
        </Typography>
    ) : null

const EliteAmendBenefitText = ({ text, placeholderMap = {} }: Props) => {
    if (!text) {
        return null
    }

    const isZeroFeeVariant = !text.includes('{strikeAmount}')

    const segments: JSX.Element[] = []
    let lastIndex = 0
    let key = 0
    let match: RegExpExecArray | null
    ELITE_SEGMENT_REGEX.lastIndex = 0

    while ((match = ELITE_SEGMENT_REGEX.exec(text)) !== null) {
        if (match.index > lastIndex) {
            segments.push(
                <TextSegment
                    key={key++}
                    bold={isZeroFeeVariant}
                    value={replacePlaceholders(text.slice(lastIndex, match.index), placeholderMap)}
                />
            )
        }
        if (match[0].includes('strikeAmount')) {
            segments.push(
                <Typography
                    key={key++}
                    className="d-inline"
                    color="subheading"
                    componentNode="span"
                    isStriked={true}
                    variant="P3"
                >
                    {replacePlaceholders(match[0], placeholderMap)}
                </Typography>
            )
        } else {
            segments.push(<ElitePill key={key++} />)
        }
        lastIndex = ELITE_SEGMENT_REGEX.lastIndex
    }

    if (lastIndex < text.length) {
        segments.push(
            <TextSegment
                key={key++}
                bold={isZeroFeeVariant}
                value={replacePlaceholders(text.slice(lastIndex), placeholderMap)}
            />
        )
    }

    return <Fragment>{segments}</Fragment>
}

export default EliteAmendBenefitText
